import {getAccessoryIcon, getEntityUrl} from "../../util";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {findListItemRole} from "../../repository/EntityRepository";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {Link} from "gatsby";
import React from "react";

export const BaseInlineListHeadlineLayout = ({ entity, listRole, classes }) => {
    const title1 = listRole?.line1 || entity.title || '';
    const title2 = listRole?.line2 || false;
    const image = entity.smallImage ? getImage(entity.smallImage.localFile) : null;
    classes = classes || {}

    const sublistStyles = {
        ...(listRole?.backgroundColor ? {backgroundColor: listRole.backgroundColor} : {}),
        ...(listRole?.textColor ? {color: listRole.textColor} : {})
    }

    return (
        <div className={"list-item inlinelist-item inlinelist-headline"}>
            <li className={classes.listItem} style={sublistStyles}>
                <div className={classes.titleFlex}>
                    <h2 className={classes.titleDiv}>
                        <div className={classes.title1}>{title1}</div>
                        <div className={classes.title2}>{title2}</div>
                    </h2>
                </div>
                {image && <GatsbyImage image={image} alt={title1} layout="fullWidth" />}
            </li>
        </div>
    )
}

export const BaseListItemLayout = ({ entity, title1, title2, title3, numCode, pageContext, sublistRole, image, associatedEntity, oaiRole, config, classes, imageLayout }) => {
    const { defaultLocale } = pageContext;
    const AccessoryIcon = getAccessoryIcon({ defaultIcon: ArrowForwardIosIcon, role: findListItemRole(entity)});
    const listType = config?.listType || 'standard'
    const displayOnlyTitles = listType === 'titleOnly'
    classes = classes || {}

    return (
        <div style={{ position: 'relative' }} className={"list-item" + (sublistRole ? " inlinelist-item" : "")}>
            <Link to={getEntityUrl({ entity, defaultLocale })} className={classes.listLink} >
                {image && imageLayout && imageLayout === 'hero' && !displayOnlyTitles && (
                    <GatsbyImage
                        className={classes.listImg + " hero"}
                        image={image}
                        alt={title1}
                        layout="fullWidth"
                    />
                )}
                <li className={classes.listItem}>
                    { sublistRole && sublistRole.backgroundColor && !displayOnlyTitles && <div className="inlinelist-marker" style={{ backgroundColor: sublistRole.backgroundColor }}> </div>}
                    {image && imageLayout !== 'hero' && image && !displayOnlyTitles && (
                        <GatsbyImage
                            className={classes.listImg}
                            image={image}
                            alt={title1}
                            layout="fullWidth"
                        />
                    )}
                    <div className={classes.titleFlex}>
                        <div className={classes.titleDiv + " list-item-title"}>
                            <div className={classes.title1 + " searchable"}>{title1}</div>
                            <div className={classes.title2 + " searchable"}>{title2}</div>
                            <div className={classes.title3 + " searchable"}>{title3}</div>
                            {!displayOnlyTitles && <div className={classes.playButton}>
                                <AccessoryIcon color="secondary" fontSize="small" />
                            </div>}
                        </div>
                    </div>
                    <div className={classes.numCode}>{numCode}</div>
                </li>
            </Link>
            { associatedEntity && !displayOnlyTitles && associatedEntity.entity &&
                <div className={classes.associatedEntity}>
                    <Link to={getEntityUrl({ entity: associatedEntity.entity, defaultLocale })} {...(associatedEntity.title && { title: associatedEntity.title })} >
                        <span className={classes.associatedLinkText}>{associatedEntity.text && associatedEntity.text}</span>
                        <span className={classes.associatedLinkIcon} role={"img"} aria-label={"information icon"}>&nbsp;ℹ️</span>
                    </Link>
                </div>
            }
        </div>
    )
}

export const HeroBaseListItemLayout = (props) => {
    return <BaseListItemLayout {...props} imageLayout={"hero"} />
}
